import React from "react";
import { process } from "../mock";

export default function Process() {
  return (
    <section className="section-pad relative" style={{ background: "linear-gradient(180deg, #070B5F 0%, #030524 100%)" }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto reveal">
          <div className="flex justify-center"><span className="gold-bar" /></div>
          <div className="text-xs uppercase tracking-[0.28em] font-semibold mt-3" style={{ color: "#8DC63F" }}>How It Works</div>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold mt-3 text-white">
            Four steps to your <span className="text-gold-grad">new home</span>.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-4 gap-6 relative">
          {/* Connector line */}
          <div className="hidden md:block absolute top-16 left-[12%] right-[12%] h-px" style={{ background: "linear-gradient(90deg, transparent, rgba(141,198,63,0.5), transparent)" }} />

          {process.map((p, i) => (
            <div key={p.step} className="reveal relative" style={{ transitionDelay: `${i * 100}ms` }}>
              <div className="glass-dark rounded-2xl p-6 h-full hover:-translate-y-1 transition-transform duration-300">
                <div className="w-14 h-14 rounded-2xl flex items-center justify-center relative z-10" style={{ background: "linear-gradient(135deg, #8DC63F, #6BA82E)", boxShadow: "0 8px 20px -6px rgba(141,198,63,0.6)" }}>
                  <span className="font-serif font-bold text-xl" style={{ color: "#070B5F" }}>{p.step}</span>
                </div>
                <h3 className="font-serif text-xl font-semibold mt-5 text-white">{p.title}</h3>
                <p className="text-white/65 text-sm mt-2 leading-relaxed">{p.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
